import { PaymentFamily } from "../model/Charge";

const findSurchargeByfamily = (fam, list) =>
  list.find(item => item.fam === fam);

const getAmountFromSurcharge = (dueAmount, surcharge, feeRenderMode) => {
  // surcharge will have render mode type
  if (feeRenderMode && feeRenderMode === "INCLUSIVE") {
    return surcharge ? surcharge.total : dueAmount;
  }

  return dueAmount;
};

export const getPaymentFamilyFromPathname = pathname => {
  if (pathname) {
    const paymentPath = pathname.split("/").pop();
    switch (paymentPath) {
      case "savedcard":
        return PaymentFamily.CARD;
      case "card":
        return PaymentFamily.CARD;
      case "ib":
        return PaymentFamily.NET_BANKING;
      case "upi":
      case "upiqr":
        return PaymentFamily.UPI;
      case "wallet":
        return PaymentFamily.WALLET;
      case "emi":
        return PaymentFamily.EMI;
      default:
        return PaymentFamily.UNKNOWN;
    }
  }
  return PaymentFamily.UNKNOWN;
};

export const calculateAmount = (
  dueAmount,
  pathname,
  surcharges,
  feeRenderMode
) => {
  if (surcharges) {
    const paymentFamily = getPaymentFamilyFromPathname(pathname);
    if (paymentFamily !== PaymentFamily.UNKNOWN) {
      return getAmountFromSurcharge(
        dueAmount,
        findSurchargeByfamily(paymentFamily, surcharges),
        feeRenderMode
      );
    }
  }
  return dueAmount;
};
